import { Box, Dropdown } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';

export default function TableDropdown({
  selectedOption,
  options,
  onSelect,
  ...rest
}) {
  return (
    <Box className={styles.ddWrapper} {...rest}>
      <Dropdown className={styles.dd}>
        <Dropdown.Button
          type="button"
          variant="dropdownTransparent"
          className={styles.ddButton}
          text={selectedOption.text}
        />
        <Dropdown.Items className={styles.ddItems} clickClose>
          {options.map((option) => (
            <Dropdown.Default
              key={option.id}
              ellipsis
              onClick={() => onSelect(option)}
            >
              {option.text}
            </Dropdown.Default>
          ))}
        </Dropdown.Items>
      </Dropdown>
    </Box>
  );
}
